import type { Account, RestoreAccount, SourceAccount } from '@repo/api-gw-sdk';

import { CloudProviders } from '@/data/inventory/data';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { getAccountProvider } from '@/utils/accounts';

import { MultiSelectConditionPanel } from '../conditions/conditionComponents';
import { CircleImage } from '../shared/circleImage';

export const AccountCondition = (
  props: {
    accounts?: Account[] | SourceAccount[] | RestoreAccount[];
  } & MultiSelectConditionComponentProps
) => {
  return (
    <MultiSelectConditionPanel
      showAddNewButton
      showSearchBox
      isLoading={props.isLoading ?? false}
      entityName={props.entityName || props.property.displayName.toLowerCase()}
      shouldShowId
      options={(props.accounts || []).map((account) => {
        const cloudProvider = getAccountProvider(account);

        return {
          id: account.providerAccountId,
          name: account.name,
          Image: CloudProviders[cloudProvider] && (
            <CircleImage
              alt={CloudProviders[cloudProvider].displayName}
              src={CloudProviders[cloudProvider].logo}
              className='my-[16px]'
            />
          ),
        };
      })}
      {...props}
    />
  );
};
